import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsSchemesConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-config',
	path: '/secure/admin/ConfigureFieldLayoutScheme([!%]?[\\w]*).jspa',
};
